'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _isComponent = require('./isComponent');

var _isComponent2 = _interopRequireDefault(_isComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (elements, Component) {
  var arr = _react.Children.toArray(elements);
  for (var i = 0; i < arr.length; i++) {
    if ((0, _isComponent2.default)(arr[i], Component)) {
      return arr[i];
    }
  }
};